import PropTypes from "prop-types"
import React from "react"
import FooterBar from "../components/footerbar"

const Footer = ({ siteTitle }) => (
  <footer className="footer">
    <FooterBar siteTitle={siteTitle} />
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
